import { emailRegex, urlRegex, urlWithRelaxedSchemeRegex } from '../utils/regexUtils'

export const requiredField =
  (message = 'This field is required') =>
  value => {
    if (!value) return message
    if (Array.isArray(value) && value.length < 1) return message

    return undefined
  }

export const emailText =
  (message = 'This field must be a valid email') =>
  value => {
    const expression = emailRegex.test(value)
    return expression ? undefined : message
  }

export const nonEmptyText =
  (message = 'This field requires at least one non-whitespace character') =>
  value => {
    const expression = !value || value.trim().length > 0
    return expression ? undefined : message
  }

export const maxLengthText =
  (maxLength, message = 'The maximum length possible is') =>
  value => {
    const expression = !value || value.length <= maxLength
    return expression ? undefined : `${message} ${maxLength}`
  }

export const urlText =
  (message = 'This field must be a valid URL') =>
  value =>
    !value || urlRegex.test(value) ? undefined : message

export const urlWithRelaxedSchemeText =
  (message = 'This field must be a valid URL') =>
  value => {
    const expression = !value || urlWithRelaxedSchemeRegex.test(value)
    return expression ? undefined : message
  }

export const minLength = (minLengthParam, message) => value => !value || value.length < minLengthParam ? message : undefined

export const numberWithinRange = (min, max, message) => value => {
  const expression = value && value > Number(0) && (Number(value) < min || Number(value) > max)
  return expression ? message : undefined
}

export const commaInSearch =
  (message = 'Please search for one item at a time') =>
  value => {
    const lastValue = value[value.length - 1]
    if (lastValue && lastValue.label && lastValue.label.includes(',')) return message
    return undefined
  }

export const positiveIntegerRequired =
  (message = 'Must be a positive number') =>
  value => {
    const expression = value && Number(value) < Number(0)
    return expression ? message : undefined
  }

export const nonZeroNumberRequired =
  (message = 'Must be greater than zero') =>
  value => {
    const expression = value && Number(value) === Number(0)
    return expression ? message : undefined
  }

export const nonDecimalNumberRequired =
  (message = 'Cannot be a decimal number') =>
  value => {
    const expression = value && !Number.isInteger(Number(value))
    return expression ? message : undefined
  }
